var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { ChevronUp, ChevronDown } from '@sumup/icons';
import styled from '../../../../styles/styled';
import { hideVisually } from '../../../../styles/style-mixins';
const baseStyles = ({ theme }) => css `
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 36px;
  width: ${theme.spacings.giga};
  position: absolute;
  left: 0;
  top: 50%;
  opacity: 0;
  transform: translateY(-50%);
  transition: opacity ${theme.transitions.default};
  color: var(--cui-fg-accent);
  border: 0;
  background: none;
  outline: 0;
  padding: 2px 4px;
  margin: 0;
  cursor: pointer;

  &:focus {
    opacity: 1;

    &::-moz-focus-inner {
      border: 0;
    }
  }
`;
const Button = styled.button(baseStyles);
const iconStyles = css `
  margin: -2px 0;
`;
const Label = styled('span')(hideVisually);
/**
 * SortArrow for the Table component. The Table handles rendering it.
 */
const SortArrow = (_a) => {
    var { label, direction } = _a, props = __rest(_a, ["label", "direction"]);
    return (_jsxs(Button, Object.assign({ role: "button", title: label }, props, { children: [direction !== 'ascending' && _jsx(ChevronUp, { size: "16", css: iconStyles }), direction !== 'descending' && _jsx(ChevronDown, { size: "16", css: iconStyles }), _jsx(Label, { children: label })] })));
};
export default SortArrow;
